// extracted by mini-css-extract-plugin
module.exports = {"HeaderBackground":"PageTitleCard_HeaderBackground__3b-9l","CardBody":"PageTitleCard_CardBody__JUTAi"};